import { MentorFQA } from "../models/mentor-fqa.model";

export const MENTOR_FQA: MentorFQA[] = [
  {
    'question': '美国的投行对于中国学生来说是不是很难进呢？',
    'answer': '投行对于中国人美国人都非常难进，美国投行的基本结构分前台和中后台，前台主要是和客户打交道比如股票、债券交易，公司并购等。中后台主要是对前台的支持，比如建造交易模型，风险管理，审计，IT等。相对于中国学生来说，前台是比较有挑战性的，因为前台很多是和客户打交道，语言和社会关系网是最大的问题。中国人比较适合的还是侧重于技术方面的职位，集中在中后台，比如说量化模型的建立等。'
  },
  {
    'question': '在投行的招聘过程中，有哪些方面是比较看重的？自身应该注意加强哪些方面呢？',
    'answer': '在投行的招聘中，有几个方面是比较看重的。首先是学生的学校，学习的项目和学校所在地。每个投行都有自己的目标学校，当然学校越好，进入投行的可能性越大，比如说常春藤、密歇根大学、纽约大学等，比较容易成为投行的target school。地域也会后一定的因素，纽约附近的学校就会相对有一些优势，像是纽约的福德汉姆大学在专业排名和综合排名都不算考前，但在华尔街各大投行还是会有很多校友，在招聘的过程中也会相对有一些优势。还有就是学生本身的专业技能的积累和实习方面的经验，专业方面有一个体现的方面就是学习成绩GPA来考察学生的学习能力，以及通过学生的syllabus看学生有没有学过相关的专业课。最后是工作的能力，投行对于相关的实习经历是十分看重的，如果你有一两段相关的实习，对于日后找投行方面的工作有非常大的帮助。'
  },
  {
    'question': '管理咨询（consulting）日常的工作是什么样的呢？',
    'answer': '所谓的管理咨询主要是和高级别的管理人员做一些Strategic project，各个公司对Strategic project的要求也不同，比如说帮助一个公司进入国外市场，给客户公司的产品提一些建议，例如这个产品是否适合现在的市场等。'
  },
  {
    'question': '四大公司面试中会遇到的什么样的状况，该怎么应对？怎么样去准备面试呢？',
    'answer': 'Behavior question是必须要准备的，首先要有一个文件列出来你能想到的会被问到的问题，最好准备4-5个。Skills方面招聘官比较看重的是communication skill。除了behavior questions，面试官会给2-3个case study，考验反应能力和解决问题的能力。比较重要的一点就是自信，不要过度在意自己的发音是否准确，所有问题可以讲清楚就好。'
  },
  {
    'question': '选什么专业对进入consultant公司有优势？有CPA证书对进入四大有帮助吗？',
    'answer': '实际上没有什么专业对于进入consulting更有利或不利，如果你会一些technical的技能像是SQL等会有一些帮助。不过咨询顾问日常工作最常用的还是Microsoft工具例如Excel。相比于很好的专业，有相关的实习经历对于进入consulting行业会更有帮助一些。而考CPA对于进入管理咨询行业并不是很有帮助，对于这样的学生更适合做advisory等，因为管理自询其实和accounting并没什么相关性。'
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/mentor-fqas.ts